<!--  -->
<template>
  <div class="opd_box">
    <div class="choose_qubox">
      <div class="sertitle">
        企业名称：
      </div>
      <div>
        <el-select
          v-model="corpId"
          placeholder="请搜索关键词"
          filterable
          remote
          reserve-keyword
          :loading="loading"
          :remote-method="fetchCampaignAccountsList"
          @change="getSelectData"
        >
          <el-option
            v-for="item in campaignAccountsList"
            :key="item.id"
            :label="item.corpName"
            :value="item.id"
          />
        </el-select>

      </div>
    </div>

    <div class="choose_qubox">
      <div class="sertitle">
        应用名称：
      </div>
      <div>
        <el-input v-model="name" style="width:350px" placeholder="请输入内容" />
      </div>
    </div>

    <div class="choose_qubox">
      <div class="sertitle">
        AppId：
      </div>
      <div>
        <el-input v-model="appId" style="width:350px" placeholder="请输入appId" />
      </div>
    </div>
    <div class="choose_qubox">
      <div class="sertitletext">
        appSecret：
      </div>
      <div>
        <el-input v-model="appSecret" style="width:350px" placeholder="请输入app密钥" />
      </div>
    </div>
    <div class="choose_qubox">
      <div class="sertitletext">
        encryptKey：
      </div>
      <div>
        <el-input v-model="encryptKey" style="width:350px" placeholder="请输入加密密钥" />
      </div>
    </div>
    <div class="choose_qubox">
      <div class="sertitletext">
        validationToken：
      </div>
      <div>
        <el-input v-model="validationToken" style="width:350px" placeholder="请输入加密密钥" />
      </div>
    </div>
    <div class="onbtn">
      <el-button type="primary" @click="onbtnclick">确定</el-button>
    </div>
  </div>
</template>

<script>
import { addapplication, enterprisefiltering, updatefiltering } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      campaignAccountsList: [],
      corpId: '',
      name: '',
      appId: '',
      appSecret: '',
      encryptKey: '',
      validationToken: '',
      loading: false,
      newedittype: null, // 新增1 编辑2
      ids: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val, obj) {
      this.fetchCampaignAccountsList()
      if (val === 1) {
        console.log('val', val)
        console.log('新增')
        this.newedittype = val
      } else {
        console.log('val obj', val, obj)
        this.corpId = obj.corpId
        this.ids = obj.id
        this.name = obj.name
        this.appId = obj.appId
        this.appSecret = obj.appSecret
        this.encryptKey = obj.encryptKey
        this.validationToken = obj.validationToken
        this.newedittype = val
        console.log('编辑')
      }
    },
    async onbtnclick() {
      if (this.corpId === '') {
        this.$message.error('请选择企业名称')
        return
      }
      if (this.name === '') {
        this.$message.error('请填写应用名称')
        return
      }
      if (this.appId === '') {
        this.$message.error('请填写AppId')
        return
      }
      if (this.appSecret === '') {
        this.$message.error('请填写appSecret')
        return
      }
      if (this.encryptKey === '') {
        this.$message.error('请填写encryptKey')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.newedittype == 1) {
        console.log('新增')
        const data = await addapplication({
          corpId: this.corpId,
          name: this.name,
          appId: this.appId,
          appSecret: this.appSecret,
          encryptKey: this.encryptKey,
          validationToken: this.validationToken
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        console.log('data', data)
      }
      // eslint-disable-next-line eqeqeq
      if (this.newedittype == 2) {
        console.log('编辑')
        const data = await updatefiltering({
          id: this.ids,
          corpId: this.corpId,
          name: this.name,
          appId: this.appId,
          appSecret: this.appSecret,
          encryptKey: this.encryptKey,
          validationToken: this.validationToken
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        console.log('data', data)
      }

      this.$emit('appcallback')
    },

    // 获取推广计划列表
    fetchCampaignAccountsList(query) {
      if (query !== '') {
        this.loading = true
        enterprisefiltering({
          corpName: query
        }).then(res => {
          this.campaignAccountsList = res.data
          this.loading = false
        })
      } else {
        this.campaignAccountsList = []
      }
    },
    // 推广计划id
    getSelectData(item) {
      this.corpId = item
      console.log('item', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.opd_box{
}
.choose_qubox{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.sertitle{
     width: 116px;
  text-align: right;
}
.sertitletext{
     width: 116px;
  text-align: right;
}
.onbtn{
  margin: 20px 0px 0px 350px;
}
</style>
